import cn from 'classnames';
import PropTypes from 'prop-types';

import { ArrowCaretItalic } from '../../icons/analytics';
import { cymbioColors } from '../../../utils/colors';
import { NEGATIVE, POSITIVE } from '../../../constants/mainConstants';

import styles from './AnalyticsMetrics.module.scss';

const caretColor = {
  [POSITIVE]: cymbioColors.analytics.darkGreen,
  [NEGATIVE]: cymbioColors.analytics.darkRed,
};

export function AnalyticsMetricTrend({ percentageChange, percentageTrend = POSITIVE, caretTrend = POSITIVE }) {
  return (
    <span className={styles.prevValueWrapper}>
      {percentageChange ? (
        <span className={cn(styles.trend, styles[percentageTrend], caretTrend === NEGATIVE ? styles.caretDown : '')}>
          {Math.abs(percentageChange).toFixed(2)}%
          <ArrowCaretItalic color={caretColor[percentageTrend]} />
        </span>
      ) : null}
    </span>
  );
}

AnalyticsMetricTrend.propTypes = {
  percentageChange: PropTypes.number.isRequired,
  percentageSign: PropTypes.string,
  caretTrend: PropTypes.string,
};
